module.exports = __webpack_public_path__ + "static/media/ankita_vaid.f57cadfb.jpg";